// react imports
import React, { useState } from "react";

// prime imports
import { Button } from "primereact/button";

// custom components
import AttachmentDialog from "../../../common/dialogs/attachment-dialog/AttachmentDialog";
import AddActionPlanModal from "../../../common/dialogs/add-action-plan-dialog/AddActionPlanDialog";


// styles
import "./ProjectSidepanel.scss"

/**
 * 
 * @param project
 * @returns 
 */
const ProjectSidepanel = (props) => {
  // states
  const [attachmentDialogVisible, setAttachmentDialogVisible] = useState(false);
  const [addActionPlanDialogVisible, setAddActionPlanDialogVisible] = useState(false);

  return (
    <div className="single-element-sidepanel project">
      <div className="single-element-sidepanel-list activities">
        <title>Related action plans</title>
        {props.project.actionPlans.map(actionPlan => (
          <div className="sidepanel-list-item action-plan" key={actionPlan}>
            <div className="item-content">
              <i className="las la-clipboard-check"></i>
              <span>{actionPlan}</span>
            </div>
            <div className="remove-button" onClick={() => console.log(actionPlan)}>
              <i className="las la-times"></i>
            </div>
          </div>
        ))}

        <Button
          icon="las la-clipboard-check"
          label="Add related action plan"
          className="p-button-text link-activity"
          onClick={() => setAddActionPlanDialogVisible(true)}
        />

        <AddActionPlanModal
          dialogVisible={addActionPlanDialogVisible}
          dialogHeader="Add Action Plan"
          onClose={() => setAddActionPlanDialogVisible(false)}
          onSave={() => setAddActionPlanDialogVisible(false)}
        />
      </div>

      <div className="single-element-sidepanel-list institutions">
        <title>Institutions</title>
        {props.project.institutions.map(institution => (
          <div className="sidepanel-list-item" key={institution}>
            <div className="item-content">
              <span>{institution}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="single-element-sidepanel-list attachments">
        <title>Attachments</title>
        {props.project.attachments.map(attachment => (
          <div className="sidepanel-list-item" key={attachment.name}>
            <a className="item-content" href={attachment.url} target="_blank" rel="noreferrer">
              <i className="lar la-file"></i>
              <span>{attachment.name}</span>
            </a>
            <div className="remove-button" onClick={() => console.log(attachment.name)}>
              <i className="las la-times"></i>
            </div>
          </div>
        ))}

        <Button
          icon="las la-plus-circle"
          label="Add attachments"
          className="p-button-text"
          onClick={() => setAttachmentDialogVisible(true)}
        />

        <AttachmentDialog
          dialogVisible={attachmentDialogVisible}
          dialogHeader="Add Attachment"
          onClose={() => setAttachmentDialogVisible(false)}
          onSave={() => setAttachmentDialogVisible(false)}
        />
      </div>
    </div>
  );
};

export default ProjectSidepanel;